import { createApp } from 'vue';
import { PerfectScrollbarPlugin } from 'vue3-perfect-scrollbar';
import Erecepta from './components/Erecepta/Erecepta.vue';
import Ezwolnienie from './components/Ezwolnienie/Ezwolnienie.vue';
import Tabletka from './components/Tabletka/Tabletka.vue';
import Antykoncepcja from './components/Antykoncepcja/Antykoncepcja.vue';
import Konsultacja from './components/Konsultacja/Konsultacja.vue';
import KonsultacjaPsychiatryczna from './components/KonsultacjaPsychiatryczna/KonsultacjaPsychiatryczna.vue';
import Skierowanie from './components/Skierowanie/Skierowanie.vue';
import SkierowanieSpecific from './components/SkierowanieSpecific/SkierowanieSpecific.vue';
import SkierowanieCT from './components/SkierowanieCT/SkierowanieCT.vue';
import PatientRegistration from './components/PatientRegistration/PatientRegistration.vue';
import Marihuana from './components/Marihuana/Marihuana.vue';

const app = createApp({});

app.use(PerfectScrollbarPlugin);

app.component('erecepta', Erecepta);
app.component('ezwolnienie', Ezwolnienie);
app.component('tabletka', Tabletka);
app.component('antykoncepcja', Antykoncepcja);
app.component('konsultacja', Konsultacja);
app.component('konsultacjapsychiatryczna', KonsultacjaPsychiatryczna);
app.component('skierowanie', Skierowanie);
app.component('skierowaniespecific', SkierowanieSpecific);
app.component('skierowaniect', SkierowanieCT);
app.component('patientregistration', PatientRegistration);
app.component('marihuana', Marihuana);

app.mount('#app');
